import { render, staticRenderFns } from "./ElSplit.vue?vue&type=template&id=606c484e&scoped=true&"
import script from "./ElSplit.vue?vue&type=script&lang=ts&"
export * from "./ElSplit.vue?vue&type=script&lang=ts&"
import style0 from "./ElSplit.vue?vue&type=style&index=0&id=606c484e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c484e",
  null
  
)

export default component.exports